import * as types from "./mutation-type";
import { getCompanyAvailabilityQuery } from "./queries.graphql";
import gqlClient from "@/modules/graphql";
import api from "@/modules/api";

const actions = {
  //fetch all company availabilities
  async getAvailabilities({ commit }, variables = {}) {
    try {
      commit(types.GET_AVAILABILITIES_BEGIN);

      const {
        data: {
          data: {
            company: { availabilities }
          }
        }
      } = await gqlClient.query({
        query     : getCompanyAvailabilityQuery,
        variables : variables
      });
      commit(types.GET_AVAILABILITIES_SUCCESS, availabilities);
    } catch (e) {
      commit(types.GET_AVAILABILITIES_ERROR, e);
    }
  },

  //delete availability
  async deleteAvailability({ commit }, id) {
    try {
      commit(types.DELETE_AVAILABILITY_BEGIN);
      await api.availability.deleteCompanyAvailability(id);
      commit(types.DELETE_AVAILABILITY_SUCCESS, id);
    } catch (e) {
      commit(types.DELETE_AVAILABILITY_ERROR, e);
    }
  },

  //create new availability
  async createAvailability({ commit }, variables ) { 
    try {
      commit(types.CREATE_AVAILABILITY_BEGIN)
      const { data } = await api.availability.addAvailability(variables)
      commit(types.CREATE_AVAILABILITY_SUCCESS, data)
    } catch (e) {
      commit(types.CREATE_AVAILABILITY_ERROR, e)
    }
  },

  //update availability by its id
  async updateAvailability({ commit }, { id, data }){
    commit(types.UPDATE_AVAILABILITY_BEGIN)
    try {
      const { data : updatedData } = await api.availability.update(id,data)
      commit(types.UPDATE_AVAILABILITY_SUCCESS, updatedData)
    } catch (error) {
      commit(types.UPDATE_AVAILABILITY_ERROR, error)
    }
  },
  
  //create new availability schedule
  async createAvailabilitySchedule({ commit, rootState }, variables  ) { 
    try {
      commit(types.ADD_AVAILABILITY_SCHEDULE_BEGIN)
      const { data } = await api.availabilitySchedule.addAvailabilitySchedule(variables)
      commit(types.ADD_AVAILABILITY_SCHEDULE_SUCCESS,{ rootState,data })
    } catch (e) {
      commit(types.ADD_AVAILABILITY_SCHEDULE_ERROR, e)
    }
  },

  async deleteAvailabilitySchedule({ commit, rootState }, id ) { 
    try {
      commit(types.DELETE_AVAILABILITY_SCHEDULE_BEGIN)
      await api.availabilitySchedule.delAvailabilitySchedule(id)
      commit(types.DELETE_AVAILABILITY_SCHEDULE_SUCCESS, { rootState, id })
    } catch (e) {
      commit(types.DELETE_AVAILABILITY_SCHEDULE_ERROR, e)
    }
  },

  async updateWeekday({ commit }, { id, data }){
    commit(types.UPDATE_AVAILABILITY_SCHEDULE_WEEKDAY_BEGIN)
    try {
      await api.availabilitySchedule.update(id, data)
      commit(types.UPDATE_AVAILABILITY_SCHEDULE_WEEKDAY_SUCCESS)
    } catch (error) {
      commit(types.UPDATE_AVAILABILITY_SCHEDULE_WEEKDAY_ERROR, error)
    }
  },

  async updateFromTime({ commit, rootState }, { id, data }){
    commit(types.UPDATE_AVAILABILITY_SCHEDULE_FROM_TIME_BEGIN)
    try {
      const { data : updatedData } = await api.availabilitySchedule.update(id, data)
      commit(types.UPDATE_AVAILABILITY_SCHEDULE_FROM_TIME_SUCCESS, { rootState,updatedData })
    } catch (error) {
      commit(types.UPDATE_AVAILABILITY_SCHEDULE_FROM_TIME_ERROR, error)
    }
  },

  async updateToTime({ commit, rootState }, { id, data }){
    commit(types.UPDATE_AVAILABILITY_SCHEDULE_TO_TIME_BEGIN)
    try {
      const { data : updatedData } = await api.availabilitySchedule.update(id, data)
      commit(types.UPDATE_AVAILABILITY_SCHEDULE_TO_TIME_SUCCESS, { rootState, updatedData })
    } catch (error) {
      commit(types.UPDATE_AVAILABILITY_SCHEDULE_TO_TIME_ERROR, error)
    }
  },

  //create user availability template
  async assignUserAvailabilityTemplate({ commit }, data  ) { 
    commit(types.ADD_USER_AVAILABILITY_TEMPLATE_BEGIN)
    try {
      const { data: updatedData } = await api.applyAvailabilityTemplate.addAvailabilityTemplate(data)
      commit(types.ADD_USER_AVAILABILITY_TEMPLATE_SUCCESS,  { updatedData })
    } catch (e) {
      commit(types.ADD_USER_AVAILABILITY_TEMPLATE_ERROR, e)
    }
  },
};

export default actions;